'use client';

import { c as _c } from "react/compiler-runtime";
import Map from '@/features/galaxy/Map';
export default function Galaxy(t0) {
  const $ = _c(3);
  const {
    mapState,
    pulseDelays
  } = t0;
  let t1;
  if ($[0] !== mapState || $[1] !== pulseDelays) {
    t1 = <section id="galaxy" className="flex h-full w-full flex-col gap-4"><Map map={mapState} pulseDelays={pulseDelays} /></section>;
    $[0] = mapState;
    $[1] = pulseDelays;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}